import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import MainContentInnerHtml from 'components/MainContentInnerHtml';
import MaxWidthPageImage from 'components/MaxWidthPageImage';
import Page from 'components/Page';
import { getRoute } from '@common/constants/CampusRoutes';
import store from 'store';

import StrengthsImageSrc from '@common/assets/images/about-me/strengths/strengths_lg.jpg';
import useModel from '@common/helpers/useModel';
import StudentProfileModel, {
	IStudentProfileModel,
} from '@common/models/StudentProfile/StudentProfile';

function StrengthsPage() {
	const navigate = useNavigate();

	const studentProfile: IStudentProfileModel = useModel(
		StudentProfileModel,
		{ id: store.currentStudentId },
		[store.currentStudentId],
		{
			disableFetch: true,
		},
	);

	const handleGoBack = () => {
		navigate(getRoute(['REPORT', 'ABOUT']));
	};

	useEffect(() => {
		studentProfile.fetchStudent(!!store?.profile?.parent);
	}, []);

	return (
		<Page
			type="content"
			title="Strengths"
			onGoBack={handleGoBack}
			isLoading={studentProfile.loading}
		>
			<MainContentInnerHtml text={studentProfile.strength?.title} />
			<MaxWidthPageImage alt="Main Strengths image" src={StrengthsImageSrc} />
			<MainContentInnerHtml text={studentProfile.strength?.description} />
		</Page>
	);
}

export default observer(StrengthsPage);
